module.exports = __webpack_public_path__ + "assets/img/online_24h.fe13f273.svg";